<template>
    <!-- App Header -->
    <SideHeader :indexPage="true" />

    <!-- * App Header -->

    <!-- App Capsule -->
    <div id="refresh-container">
        <div style="padding-top: 55px;">
            <Placeholder v-if="loading" />
            <div v-else style="background-color: white">
                <div class="section" :class="{ 'mt-3 mb-3': index !== 0, 'mt-0 mb-3 pt-45': index == 0 }"
                    v-for="(cargo, index) in cargos" :key="index.id">
                    <CardView :cargo="cargo" />
                </div>
                <button @click="nextLoadCargo()" class="btn btn-warning btn-block btn-lg"
                    v-if="mode == 1 && loadingNext == 0">
                    نمایش بار های بیشتر کلیک کنید...
                </button>
                <button class="btn btn-success btn-lg btn-block" type="button" v-if="loadingNext == 1" disabled>
                    <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
                    درحال بارگذاری ...
                </button>
            </div>
            <a href="#" class="button goTop show">
                <ion-icon name="arrow-up-outline"></ion-icon>
            </a>
        </div>
    </div>


</template>
<script>
import Placeholder from "@/components/Placeholder.vue";
import axios from "axios";
import Swal from "sweetalert2";
import CardView from "./CardView.vue";
import delivery_methods from "@/delivery_methods";
import SideHeader from "@/components/SideHeader.vue";
import PullToRefresh from "pulltorefreshjs";

export default {
    name: "Master",
    components: {
        SideHeader,
        CardView,
        Placeholder,
        // Footer
    },
    data() {
        return {
            mode: 0,
            results: [],
            cargos: [],
            city: this.$route.params.city,
            show: false,
            loading: false,
            axiosConfig: {
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
                    'Accept': 'application/json'
                }
            },
            loadingNext: 0,
        };
    },
    methods: {
        returnLoads() {
            this.loading = true;
            axios.post(`${delivery_methods.BASE_URL}api/driver/LoadsInDestinationCity/${this.city}`,
                {
                    lastLoadId: 0
                }, this.axiosConfig
            )
                .then((response) => {
                    this.loading = false;
                    if (response.data.result == 1) {
                        this.loading = false;
                        this.mode = 1;
                        this.cargos = response.data.loads;
                        this.show = true;
                    } else {
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: 'بار مورد نظر یافت نشد',
                            showConfirmButton: true,
                            confirmButtonText: "بازگشت",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.history.go(-1); return false;
                            }
                        });
                    }

                });
        },
        nextLoadCargo() {
            this.loadingNext = 1;
            axios.post(`${delivery_methods.BASE_URL}api/driver/LoadsInDestinationCity/${this.city}`,
                {
                    lastLoadId: this.cargos[this.cargos.length - 1].id,
                }, this.axiosConfig
            )
                .then((response) => {
                    this.loading = false;
                    if (response.data.result == 1) {
                        this.cargos.push(...response.data.loads);
                        this.loadingNext = 0;
                    } else {
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: 'بار مورد نظر یافت نشد',
                            showConfirmButton: true,
                            confirmButtonText: "بازگشت",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.history.go(-1); return false;
                            }
                        });
                    }

                });
        },
        initPullToRefresh() {
            if (this.ptrInstance) {
                this.ptrInstance.destroy();
            }
            this.ptrInstance = PullToRefresh.init({
                mainElement: '#refresh-container',
                onRefresh: () => this.returnLoads()
            });
        },
        saveScrollPosition() {
            localStorage.setItem('scrollPosition', window.scrollY);
        },

    },
    beforeMount() {
        this.returnLoads();
    },
    mounted() {
        this.initPullToRefresh();
        window.addEventListener('beforeunload', this.saveScrollPosition);

    },
    beforeRouteLeave(to, from, next) {
        this.saveScrollPosition();
        next();
    },
    beforeUnmount() {
        if (this.ptrInstance) {
            this.ptrInstance.destroy();
        }
    }
};
</script>
<style>
.pt-45 {
    padding-top: 2rem !important;
}

#webpack-dev-server-client-overlay {
    display: none;
}
</style>